import { createSelector } from 'reselect';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { showSelector } from 'selectors/testTarget/offers/showPDPTopOfPageRedesign/show/showSelector';

const showPDPTopOfPageRedesignSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => {
    const globalKillswitch = !!Sephora?.configurationSettings?.pdpTopOfPage?.isEnabled;

    return globalKillswitch && testReady && show;
});

export { showPDPTopOfPageRedesignSelector };
